module.exports = __webpack_public_path__ + "static/media/scienceBoard.a5a821e6.png";